var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandLogoMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 47,
    viewBox: "0 0 88 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.9686 22.8529C74.4074 22.0252 65.0929 21.2621 54.5796 20.9263V14.7588H50.2707V20.4707H38.4226V14.7588H34.1137V20.8711C25.3836 21.1076 16.1797 21.7051 6.73254 22.804V24.9954C14.3364 24.7085 23.673 24.4357 34.1137 24.297V31.2134H38.4226V24.2481C42.2514 24.2119 46.2113 24.1945 50.2707 24.2024V31.2134H54.5796V24.2197C63.3902 24.2733 72.6147 24.4483 81.9686 24.7936V22.856V22.8529Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7392 3.87901V43.0377H3.96371V3.87901H84.7392ZM88.0088 0.714844H0.694092V46.2018H88.0088V0.714844Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandLogoMobile);
export default __webpack_public_path__ + "static/media/brand-logo-mobile.7ac697b0f398b27ca9deacd30beeb79f.svg";
export { ForwardRef as ReactComponent };